module.exports = __webpack_public_path__ + "static/media/external_env_2_product_image_1.97cd5c70.webp";